module.exports = __webpack_public_path__ + "static/media/duffey-1.e81236d7.jpg";